@if (href$ | async; as href) {
    <a class="text-nowrap"
       [routerLink]="href.path"
       [queryParams]="href.queryParams"
       adaptTooltip="Go to the '{{ linkText }}' team meetings page">
        <i [ngClass]="linkIcon"></i>
        {{ linkText }}
        <adapt-team-private-icon [team]="team"
                                 [showTooltip]="false"></adapt-team-private-icon>
    </a>
}
